var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRctRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 299,
    viewBox: "0 0 322 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M193.937 298.622L191.039 295.724L310.683 176.08C314.746 172.015 316.986 166.613 316.986 160.865C316.986 155.117 314.746 149.714 310.683 145.65L175.768 10.7349C171.704 6.67141 166.302 4.43372 160.553 4.43372C154.806 4.43372 149.401 6.67141 145.338 10.7349L10.4027 145.65C6.33915 149.714 4.09916 155.117 4.09916 160.865C4.09916 166.613 6.33915 172.015 10.4027 176.08L66.2782 231.957L63.3795 234.855L7.50398 178.979C2.6662 174.14 0 167.708 0 160.865C0 154.022 2.6662 147.59 7.50398 142.752L142.439 7.83628C147.278 2.99792 153.711 0.333984 160.553 0.333984C167.397 0.333984 173.829 2.9985 178.666 7.83628L313.581 142.751C318.419 147.589 321.086 154.022 321.086 160.864C321.086 167.707 318.42 174.14 313.581 178.977L193.937 298.622Z",
    fill: "url(#paint0_linear_740_10649)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_10649",
    x1: 74.289,
    y1: 168.983,
    x2: 318.778,
    y2: 168.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRctRight);
export default __webpack_public_path__ + "static/media/rctRight.87dd36487253580d4c541cce9a110d92.svg";
export { ForwardRef as ReactComponent };